import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=05dde789"
import script from "./SideBarMenu.vue?vue&type=script&lang=js"
export * from "./SideBarMenu.vue?vue&type=script&lang=js"
import style0 from "./SideBarMenu.vue?vue&type=style&index=0&id=05dde789&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports